import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import { Zoom } from '@commons/zoom/Zoom';
import { TranscriptBlock } from '@commons/transcript/Transcript';

import { FormWithChecklist } from '@pages-impl/ux-ui-design';
import { ChoiceOfGolang } from '@pages-impl/golang-development/why-use-golang/ChoiceOfGolang';

import * as styles from './html-render.module.scss';

const PossibleBannersToInject = {
  golang: ChoiceOfGolang,
  design: FormWithChecklist,
};

export const HTMLRender = ({ content, className }) => {
  const codilimeUrlAddress = 'https://codilime.com';
  const ref = useRef();

  useEffect(() => {
    const images = [...ref.current.querySelectorAll('p > img')];
    const links = [...ref.current.querySelectorAll('a')];
    const CustomInjectedBanners = [...ref.current.querySelectorAll('.custom-injected-banners')];
    const CustomTranscriptsBlock = [...ref.current.querySelectorAll('.custom-transcript-block')];

    for (const link of links) {
      const href = link.getAttribute('href') || '';

      if (href.startsWith('/') || href.startsWith(codilimeUrlAddress)) {
        link.removeAttribute('rel');
        link.removeAttribute('target');
      } else if (href.startsWith('#')) {
        link.removeAttribute('rel');
      } else {
        link.setAttribute('rel', 'nofollow noopener noreferrer');
      }
    }

    for (const img of images) {
      const props = Object.fromEntries([...img.attributes].map(({ name, value }) => [name, value]));
      ReactDOM.render(<Zoom data={props} />, img.parentNode);
    }

    for (const banner of CustomInjectedBanners) {
      const formType = banner.getAttribute('data-formtype');
      const BannerToRender = PossibleBannersToInject[formType];
      ReactDOM.render(<BannerToRender />, banner);
    }

    for (const transcript of CustomTranscriptsBlock) {
      const t_content = transcript.innerHTML;
      ReactDOM.render(<TranscriptBlock>{t_content}</TranscriptBlock>, transcript);
    }
  }, []);
  return (
    <div className={styles.htmlRender}>
      <div ref={ref} className={className} dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};
